import { Form } from "antd";
import { HeaderOverview } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  Wrapper,
  checkDataObject,
} from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardAppTeamUp } from "service/dashboard/central/overview";
import { SpaceStyle } from "..";

const TeamUpApp = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();
  const teamUpAppDate = Form.useWatch("teamUpAppDate");
  const date = findDate(teamUpAppDate, "month");

  const { data, isFetching, isError, error } = useGetDashboardAppTeamUp({
    property,
    ...date,
  });

  const countTeamUp = data ? checkDataObject(data) : "0";

  return (
    <Wrapper className="h-[300px]">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("number-of-user-using-app-team-up")}
          name="teamUpAppDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="200px" />
        ) : (
          <SpaceStyle className="center " direction="vertical">
            <div className="count" style={{fontSize:"36px"}}>{`${countTeamUp || "0"}`}</div>
            <div className="people" style={{fontSize:"24px"}}>{t("people")}</div>
          </SpaceStyle>
        )}
      </LoadingDashboard>
    </Wrapper>
  );
};

export default TeamUpApp;
